export default {
  'instrument-cluster': 'Instrument cluster',
  // Date range selection
  range: {
    placeholder: {
      allTime: 'All time',
      start: 'Start time',
      end: 'End time',
    },
    presets: {
      all: 'All',
      today: 'Today',
      yesterday: 'Yesterday',
      thisWeek: 'This week',
      lastWeek: 'Last week',
      thisMonth: 'This month',
      lastMonth: 'Last month',
      thisYear: 'This year',
      lastYear: 'Last year',
    },
  },
  // Statistics module
  statistics: {
    customer: 'Customer statistics',
    funds: 'Funds statistics',
    commission: 'Commission statistics',
    transactionVolume: 'Transaction volume statistics',
    transactionTrades: 'Transaction statistics (lots)',
    activeUser: 'Active user statistics',
    nationalDistribution: 'National distribution',
    loginTime: 'Login time',
    inviteCustomer: 'Invite customer',
  },
  // Common terms
  common: {
    pleaseSelect: 'Please select',
    self: 'Self',
    selfAndSubordinates: 'Self and subordinates',
    totalCustomers: 'Total customers',
    netDeposit: 'Net deposit (USD)',
    firstDeposit: 'First deposit',
    firstDepositCustomer: 'First deposit customer',
    todayNew: 'New today',
    yesterdayNew: 'New yesterday',
    direct: 'Direct',
    indirect: 'Indirect',
    directCommission: 'Direct commission',
    indirectCommission: 'Indirect commission',
    totalCommission: 'Total commission',
    tradingCommission: 'Trading commission',
    copyCommission: 'Copy-trading commission',
    pammCommission: 'PAMM commission',
    totalDeposit: 'Total deposit',
    totalWithdrawal: 'Total withdrawal',
    totalTransfer: 'Total transfer',
    totalVolume: 'Total volume',
    standardVolume: 'Standard volume',
    copyVolume: 'Copy-trading volume',
    pammVolume: 'PAMM volume',
    people: 'People',
    unit: {
      usd: 'USD',
      lotsMillion: 'Number of hands/million dollars',
    },
    selectGroup: 'Please select a group',
    inviteLink: 'Invitation link',
    inviteCode: 'Invitation code',
    downloadQR: 'Download QR code',
    inviteManagement: 'Invitation management',
    copySuccess: {
      link: 'Invitation link copied',
      code: 'Invitation code copied',
    },
    copyFailed: 'Copy failed',
    platform: {
      all: 'All',
      mt4: 'MT4',
      mt4New: 'MT4-New',
      mt5: 'MT5',
    },
    other: 'Other',
  },
  // Labels
  labels: {
    ib: 'IB',
    customer: 'Customer',
  },
}
